<ng-container *ngIf='!loading, else isLoading'>
  <div class='row'>
    <div class='column--12 mb--lg'>
      <ng-container *ngIf='invoice; else noInvoice'>
        <h2 class='mb--xxs mt--none semi-bold'>Courier: {{ invoice.providerName }}</h2>
        <h3 class='mb--sm mt--none no-bold'>
          Invoice: {{invoice.original_file_name || invoice.file_name}}<br/>
          <ng-container *ngIf='invoice.invoice_number'>{{ isUber ? 'BillID' : 'Invoice number' }}: {{ invoice.invoice_number }}<br/></ng-container>
          Date: {{invoice.created_at | timeToString : DATE_FORMAT : defaultTimezone}} <br />
          Total: {{ invoice.invoice_amount | currency }}
        </h3>
        <div class='mb--sm'>
          <span *ngIf='invoice.status' class='pill-box pill-status' [ngClass]='statusPillClass'>{{ statusText }}</span>
          <app-courier-invoice-retry-button
            *ngIf='canModifyFinance && detail.trackingAvailable'
            [invoice]='invoice'
            (retried)='onRetried()'
          ></app-courier-invoice-retry-button>
        </div>

        <div *ngIf='isUber && detail.trackingAvailable' class='mb--sm sibling-bill-ids'>
          <ng-container *ngIf='sectionNotice("siblings") as notice; else siblingChips'>
            <p class='text--sm text--danger mb--none'>{{ notice }}</p>
          </ng-container>
          <ng-template #siblingChips>
            <ng-container *ngIf='detail.siblings.length > 0'>
              <p class='text--sm mb--xxs'>Other BillIDs in this file</p>
              <nav aria-label='Other BillIDs in this file'>
                <a
                  *ngFor='let sibling of detail.siblings'
                  mat-stroked-button
                  class='sibling-link mr--xs mb--xs'
                  [routerLink]="['/finance', 'invoice-audits', sibling.id]"
                >
                  {{ sibling.invoice_number }}
                  <span class='pill-box pill-status ml--xs' [ngClass]='siblingPillClass(sibling.status)'>{{ siblingStatusText(sibling.status) }}</span>
                </a>
              </nav>
            </ng-container>
          </ng-template>
        </div>
      </ng-container>
      <ng-template #noInvoice>
        <h2 class='mb--sm'>Shipments for Invoice: {{invoiceName}}</h2>
      </ng-template>
      <a [routerLink]="['/finance/']" class='text--primary-green'>< Back to courier invoices</a>
    </div>
  </div>

  <ng-container *ngIf='detail'>
    <div class='row'>
      <div class='column--12 mb--sm'>
        <p class='outcome-banner mb--none'>{{ outcomeMessage }}</p>
      </div>
    </div>

    <div class='row mb--sm outcome-tiles'>
      <div *ngFor='let tile of tiles' class='column--12 column-md--3'>
        <mat-card class='outcome-tile h-100'>
          <mat-card-content>
            <div class='text--sm'>{{ tile.label }}</div>
            <div class='h3 semi-bold mt--none mb--none'>{{ tile.value }}</div>
            <div *ngIf='tile.subLine' class='text--sm' [class.text--danger]='tile.unavailable'>{{ tile.subLine }}</div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <mat-tab-group animationDuration='0ms'>
      <mat-tab [label]='reconciledTabLabel'>
        <div class='mt--sm'>
          <ng-container *ngIf='sectionNotice("shipments") as notice; else reconciledBody'>
            <p class='text--danger'>{{ notice }}</p>
          </ng-container>
          <ng-template #reconciledBody>
            <p *ngIf='reconciledTruncatedNote as note' class='text--sm reconciled-truncated-note'>{{ note }}</p>
            <shipments-list
              *ngIf='shipments.length > 0; else noShipments'
              [shipments]='shipments'
              [hideProvider]='true'
              [totalShipments]='shipments.length'
              [user]='user'
            ></shipments-list>
            <ng-template #noShipments>
              <p class='empty-state'>{{ reconciledEmptyState }}</p>
            </ng-template>
          </ng-template>
        </div>
      </mat-tab>

      <mat-tab *ngIf='detail.trackingAvailable' [label]='unknownTabLabel'>
        <div class='mt--sm'>
          <ng-container *ngIf='sectionNotice("unknownShipments") as notice; else unknownBody'>
            <p class='text--danger'>{{ notice }}</p>
          </ng-container>
          <ng-template #unknownBody>
            <ng-container *ngIf='detail.unknownTrackingRestricted; else unknownRows'>
              <p class='restricted-note'>
                {{ restrictedNote }} You need the Unknown Tracking permission to see these rows.
              </p>
            </ng-container>
            <ng-template #unknownRows>
              <div *ngIf='canViewUnknownTracking' class='mb--sm'>
                <a
                  mat-button
                  color='primary'
                  class='open-unknown-tracking'
                  [routerLink]="['/unknown-tracking']"
                  [queryParams]='unknownTrackingQueryParams'
                >Open in Unknown Tracking</a>
              </div>
              <p *ngIf='unknownTruncatedNote as note' class='text--sm unknown-truncated-note'>{{ note }}</p>
              <ng-container *ngIf='unknownDataSource.data.length > 0; else noUnknownRows'>
                <table mat-table [dataSource]='unknownDataSource' class='w--100'>
                  <ng-container matColumnDef='createdAt'>
                    <th mat-header-cell *matHeaderCellDef>Date</th>
                    <td mat-cell *matCellDef='let row' class='text--sm'>{{ row.createdAt | date: 'E, d MMM' }}</td>
                  </ng-container>
                  <ng-container matColumnDef='type'>
                    <th mat-header-cell *matHeaderCellDef>Type</th>
                    <td mat-cell *matCellDef='let row' class='text--sm'>
                      <span class='pill-box pill-status' [ngClass]="isDoNotBill(row) ? 'unconfirmed' : 'created'">
                        {{ isDoNotBill(row) ? 'Do not bill' : 'Unknown tracking' }}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef='trackingNumber'>
                    <th mat-header-cell *matHeaderCellDef>Tracking</th>
                    <td mat-cell *matCellDef='let row' class='text--sm cursor-pointer' (click)='copyText(row.trackingNumber)'>
                      {{ row.trackingNumber }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef='reference'>
                    <th mat-header-cell *matHeaderCellDef>Reference</th>
                    <td mat-cell *matCellDef='let row' class='text--sm'>
                      <button mat-button color='primary' class='mdc-small-button' (click)='openUnknownRow(row)'>More info</button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef='cost'>
                    <th mat-header-cell *matHeaderCellDef>Cost</th>
                    <td mat-cell *matCellDef='let row' class='text--sm'>{{ row.totalAmount | currency }}</td>
                  </ng-container>
                  <ng-container matColumnDef='reason'>
                    <th mat-header-cell *matHeaderCellDef>Reason</th>
                    <td mat-cell *matCellDef='let row' class='text--sm'>{{ reviewReason(row) }}</td>
                  </ng-container>
                  <ng-container matColumnDef='notes'>
                    <th mat-header-cell *matHeaderCellDef>Notes</th>
                    <td mat-cell *matCellDef='let row' class='text--sm'>{{ row.notes || '—' }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef='unknownColumns'></tr>
                  <tr mat-row *matRowDef='let row; columns: unknownColumns'></tr>
                </table>
                <mat-paginator #unknownPaginator [pageSize]='150' [hidePageSize]='true'></mat-paginator>
              </ng-container>
              <ng-template #noUnknownRows>
                <p class='empty-state'>No rows are waiting for review.</p>
              </ng-template>
            </ng-template>
          </ng-template>
        </div>
      </mat-tab>

      <mat-tab *ngIf='detail.trackingAvailable' [label]='failedTabLabel'>
        <div class='mt--sm'>
          <ng-container *ngIf='sectionNotice("failedRows") as notice; else failedBody'>
            <p class='text--danger'>{{ notice }}</p>
          </ng-container>
          <ng-template #failedBody>
            <p *ngIf='failedLogNote as note' class='text--sm failed-log-note'>{{ note }}</p>
            <ng-container *ngIf='failedDataSource.data.length > 0; else noFailedRows'>
              <table mat-table [dataSource]='failedDataSource' class='w--100'>
                <ng-container matColumnDef='identifier'>
                  <th mat-header-cell *matHeaderCellDef>{{ identifierLabel }}</th>
                  <td mat-cell *matCellDef='let row' class='text--sm'>{{ row.identifier || '—' }}</td>
                </ng-container>
                <ng-container matColumnDef='invoiceNumber'>
                  <th mat-header-cell *matHeaderCellDef>Invoice number</th>
                  <td mat-cell *matCellDef='let row' class='text--sm'>{{ row.invoiceNumber || '—' }}</td>
                </ng-container>
                <ng-container matColumnDef='amount'>
                  <th mat-header-cell *matHeaderCellDef>Amount</th>
                  <td mat-cell *matCellDef='let row' class='text--sm'>{{ row.amount == null ? '—' : (row.amount | currency) }}</td>
                </ng-container>
                <ng-container matColumnDef='reason'>
                  <th mat-header-cell *matHeaderCellDef>Reason</th>
                  <td
                    mat-cell
                    *matCellDef='let row'
                    class='text--sm failed-reason'
                    [matTooltip]='row.reason'
                    matTooltipClass='mtx-recon-tooltip multiline-tooltip'
                  >
                    {{ row.reason ? (row.reason | slice: 0 : 80) + (row.reason.length > 80 ? '…' : '') : '—' }}
                    <div *ngIf='isAirCanadaCargo && !row.resolvedAt' class='text--sm'>
                      Air Canada Cargo can't re-run this row automatically — ask engineering to clear it, then re-upload.
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef='attempts'>
                  <th mat-header-cell *matHeaderCellDef>Attempts</th>
                  <td mat-cell *matCellDef='let row' class='text--sm'>{{ row.attempts }}</td>
                </ng-container>
                <ng-container matColumnDef='lastFailedAt'>
                  <th mat-header-cell *matHeaderCellDef>Last failed</th>
                  <td mat-cell *matCellDef='let row' class='text--sm'>
                    {{ row.lastFailedAt | timeToString : DATE_FORMAT : defaultTimezone }}
                  </td>
                </ng-container>
                <ng-container matColumnDef='state'>
                  <th mat-header-cell *matHeaderCellDef>State</th>
                  <td mat-cell *matCellDef='let row' class='text--sm'>
                    <span class='pill-box pill-status' [ngClass]="row.resolvedAt ? 'delivered' : 'attention'">
                      {{ row.resolvedAt ? 'Resolved' : 'Open' }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef='rawRow'>
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef='let row' class='text--sm'>
                    <button *ngIf='row.rawRow' mat-button color='primary' class='mdc-small-button' (click)='openRawRow(row)'>Raw row</button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef='failedColumns'></tr>
                <tr mat-row *matRowDef='let row; columns: failedColumns'></tr>
              </table>
              <mat-paginator #failedPaginator [pageSize]='150' [hidePageSize]='true'></mat-paginator>
            </ng-container>
            <ng-template #noFailedRows>
              <p class='empty-state'>No rows failed.</p>
            </ng-template>
          </ng-template>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</ng-container>
<ng-template #isLoading>
  <div class='align-center mt--lg'>
    <app-loading></app-loading>
  </div>
</ng-template>
